/**
 * @module ol/source/common
 */

/**
 * Default WMS version.
 * @type {string}
 */
export var DEFAULT_WMS_VERSION = '1.3.0';

/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */
export var DECIMALS = 4;